import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from 'app/shared.service';
import { IPartePedimento } from '../mercancias/mercancias.component';

@Component({
  selector: 'app-pedimentos',
  templateUrl: './pedimentos.component.html',
  styleUrls: ['./pedimentos.component.scss']
})
export class PedimentosComponent implements OnInit {
  @Input() pedimento: IPartePedimento;

  pPattern = /^\d{2} \d{2} \d{4} \d{7}$/;
  FormPedimentos = new FormGroup({
    index: new FormControl(''),
    id: new FormControl(0),
    pedimento: new FormControl(null, [Validators.required, Validators.minLength(18), Validators.maxLength(18), Validators.pattern(this.pPattern)]),
});

  constructor(
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {

    this.FormPedimentos.valueChanges.subscribe(changes => {
      if (this.FormPedimentos.valid) {
          this.sharedService.setFormPedimentos(changes);
      }
  });
     //Set form
     this.FormPedimentos.setValue({
      index: this.pedimento?.index,
      id: this.pedimento?.id,
      pedimento:this.pedimento?.pedimento
  });

  }

  get f() { return this.FormPedimentos.controls; }

}
